/** @jsx jsx */
import { jsx } from "@emotion/react";
import Tooltip from "@material-ui/core/Tooltip";
import { Delete, SaveAlt } from "@material-ui/icons";
import React, { FC, ReactNode } from "react";
import { FileMetadata } from "src/requests/files/types";

import * as S from "../styles";

interface SingleFileProps {
  file: FileMetadata;
  disabled: boolean;
  deleteFile(fileId: string | number): void;
  openFile(file: FileMetadata): void;
  downloadFile(file: FileMetadata): void;
  makePlaceForInput?: boolean;
}

const SingleFile: FC<SingleFileProps> = ({
  file,
  disabled,
  deleteFile,
  openFile,
  downloadFile,
  makePlaceForInput = false,
}) => {
  const fileOnClickAction = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();

    if (disabled) {
      downloadFile(file);
      return;
    }

    deleteFile(file.id);
  };

  const renderFileActionBtn = (): ReactNode => (
    <button type="button" onClick={fileOnClickAction} css={S.noStyleButton}>
      {disabled ? (
        <SaveAlt css={S.iconStyleCss} />
      ) : (
        <Delete css={S.iconStyleCss} />
      )}
    </button>
  );

  return (
    <Tooltip title={file.fileName} placement="top-start">
      <div
        onClick={(): void => openFile(file)}
        onKeyDown={(): void => openFile(file)}
        css={S.singleFileContainer(makePlaceForInput && !disabled)}
        role="button"
        tabIndex={0}
      >
        <span css={S.fileNameCss}>{file.fileName}</span>
        {renderFileActionBtn()}
      </div>
    </Tooltip>
  );
};

export default SingleFile;
